import React, { useState } from "react";
import "./UploadDocuments.css";
import CustomDropdown from "../../../../../Components/CustomDropdown/CustomDropdown";
import Btn1Icon from "../../../../../assets/images/client-dashboard/uploaddocuments-btnupload.svg";
import Btn2Icon from "../../../../../assets/images/client-dashboard/uploaddocuments-btndownload.svg";
import Btn3Icon from "../../../../../assets/images/client-dashboard/uploaddocuments-btnplus.svg";
import Btn4Icon from "../../../../../assets/images/client-dashboard/uploaddocuments-btnminus.svg";
import UploadFileIcon from "../../../../../assets/images/admin-dashboard/uploadfile.svg";

const UploadDocuments = () => {
  return (
    <div className="cltdetails__uploaddocs_page">
      <div className="cltdetails__uploaddocs_contentwrap">
        <div className="cltdetails__uploaddocs_contentbox">
          <div className="cltdetails__uploaddocs_cboxheader">
            Upload Documents
          </div>
          <div className="cltdetails__uploaddocs_cboxbody">
            <div className="cltdetails__uploaddocs_cboxrow">
              <div className="cltdetails__uploaddocs_cboxcol">
                <div className="cltdetails__uploaddocs_cboxfieldbox">
                  <label className="cltdetails__uploaddocs_cboxfieldlbl">
                    Document Name
                  </label>
                  <div className="cltdetails__uploaddocs_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__uploaddocs_cboxfield"
                      placeholder="Enter Document Name"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__uploaddocs_cboxcol">
                <div className="cltdetails__uploaddocs_cboxfieldbox">
                  <label className="cltdetails__uploaddocs_cboxfieldlbl">
                    Document Type
                  </label>
                  <div className="cltdetails__uploaddocs_cboxfieldwrap">
                    <CustomDropdown
                      customStyles={{
                        height: 56,
                        borderColor: "lightgrey",
                        marginTop: 0,
                      }}
                      options={["opt1"]}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__uploaddocs_cboxrow">
              <div className="cltdetails__uploaddocs_cboxcol">
                <div className="cltdetails__uploaddocs_cboxfieldbox">
                  <label className="cltdetails__uploaddocs_cboxfieldlbl">
                    Comments
                  </label>
                  <div className="cltdetails__uploaddocs_cboxfieldwrap">
                    <textarea
                      type="text"
                      className="cltdetails__uploaddocs_cboxtextarea"
                      placeholder="Enter Comments"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__uploaddocs_cboxrow">
              <div className="cltdetails__uploaddocs_cboxcol">
                <div className="cltdetails__uploaddocs_cboxfieldbox">
                  <label className="cltdetails__uploaddocs_cboxfieldlbl">
                    Upload File
                  </label>
                  <label
                    className="cltdetails__uploaddocs_cboxfieldwrap"
                    for="admndash_uploadfile_field"
                  >
                    <input
                      type="file"
                      hidden
                      id="admndash_uploadfile_field"
                      accept=".doc, .docx, .pdf, .jpg, .jpeg, .png"
                    />
                    <div className="cltdetails__uploaddocs_uploadfilewrap">
                      <img
                        src={UploadFileIcon}
                        alt=""
                        className="cltdetails__uploaddocs_uploadfileicon"
                      />
                      <div className="cltdetails__uploaddocs_uploadfiletxt">
                        Upload File
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className=" cltdetails__uploaddocs_btnswrap">
          <div
            className=" cltdetails__uploaddocs_btn"
            style={{ background: "rgba(29, 66, 102, 1)" }}
          >
            <img
              src={Btn1Icon}
              alt=""
              className=" cltdetails__uploaddocs_btnicon"
            />
          </div>
          <div
            className=" cltdetails__uploaddocs_btn"
            style={{ background: "rgba(8, 182, 187, 1)" }}
          >
            <img
              src={Btn2Icon}
              alt=""
              className=" cltdetails__uploaddocs_btnicon"
            />
          </div>
          <div
            className=" cltdetails__uploaddocs_btn"
            style={{ background: "rgba(20, 176, 130, 1)" }}
          >
            <img
              src={Btn3Icon}
              alt=""
              className=" cltdetails__uploaddocs_btnicon"
            />
          </div>
          <div
            className=" cltdetails__uploaddocs_btn"
            style={{ background: "rgba(140, 153, 209, 1)" }}
          >
            <img
              src={Btn4Icon}
              alt=""
              className=" cltdetails__uploaddocs_btnicon"
            />
          </div>
        </div>
      </div>
      <div className="cltdetails__uploaddocs_contentwrap">
        <div className="cltdetails__uploaddocs_bottombtns">
          <button className="cltdetails__uploaddocs_bbtnfilled">Submit</button>
          <button className="cltdetails__uploaddocs_bbtnoutlined">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadDocuments;
